/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 12:37:42
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "@root/core/tags";
import { NumberHelper } from "@root/core/utilities/number-helper";

@UITag.set()
export class uicSquareMeters extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement, EUITagTarget.TableBodyCell];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        const target = input.target;
        switch (target) {
            case EUITagTarget.FormElement:
                return {
                    props: {
                        append: "平方公尺",
                    },
                    specials: {
                        moreTags: [
                            {
                                tag: "uiDescription",
                                rule: `(o) => {
                                    if (o.value == null) return null;
                                    return \`\${o.value} 平方公尺 = \${NumberHelper.toPrettyString(o.value * 0.3025)} 坪\`;
                                }`,
                            },
                        ],
                    },
                };
            case EUITagTarget.TableBodyCell:
                const value = input.inputs.props?.value;
                return {
                    props: {
                        append:
                            value == null
                                ? "平方公尺"
                                : `平方公尺<BR>(${NumberHelper.toPrettyString(
                                      value * 0.3025,
                                  )} 坪)`,
                    },
                };
            default:
                console.error(`<uicSquareMeters> invalid target: ${target}`);
        }
        return null;
    }
}
